<template>
  <v-container
    class="pa-0"
  >
    <v-toolbar
      flat
    >
      <v-btn
        icon
        to="/eleave/approvedAbsentTable"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ $chPtObjData('chinAbsentTypeDesc',absentRecord) }} ({{ $t('eLeave.Detail') }})
      </v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="absentRecord.details"
      :footer-props="{
        disableItemsPerPage: true
      }"
      class="v-data-footer__select-hide v-data-table--sm-dense"
    >
      <template v-slot:item.startDate="{ item }">
        <template v-if="isWholeDay(item)">
          {{ momentWithHyphen(item.startDate).format('YYYY-MM-DD') }}
        </template>
        <template v-else>
          {{ momentWithHyphen(item.startDate).format('YYYY-MM-DD HH:mm') }}
        </template>
      </template>
      <template v-slot:item.endDate="{ item }">
        <template v-if="isWholeDay(item)">
          {{ momentWithHyphen(item.endDate).format('YYYY-MM-DD') }}
        </template>
        <template v-else>
          {{ momentWithHyphen(item.endDate).format('YYYY-MM-DD HH:mm') }}
        </template>
      </template>
      <!-- <template v-slot:item.appStatus="{ item }">
        {{ $t(item.appStatus) }}
      </template>
      <template
        v-slot:item.chinAbsentTypeDesc="{ item }"
      >
        <span
          v-if="!item.details"
        >
          {{ $chPtField(item.chinAbsentTypeDesc) }}
        </span>
        <span
          v-else
          class="text-caption blue--text"
          @click="goToDetailPage(item)"
        >{{ $chPtField(item.chinAbsentTypeDesc) }}</span>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
// import { mapState } from 'vuex'
// import { eLeaveModule } from '../../store/moduleName'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiArrowLeft } from '@mdi/js'

export default {
  components: {
  },
  props: {
    absentRecord: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      headers: [
        {
          text: this.$t('eLeave.StartDateTime'),
          value: 'startDate'
        },
        {
          text: this.$t('eLeave.EndDateTime'),
          value: 'endDate'
        }
      ]
    }
  },
  methods: {
    isWholeDay: function (item) {
      if (item.startDate === item.endDate) {
        return true
      } else {
        return false
      }
    },
    momentWithHyphen: momentWithHyphen
  }
  //   created () {
  //     this.$store.dispatch(eLeaveModule + '/getFaltasRecords', 2)
  //     // this.$store.dispatch(coursesModule + '/getProposalFormReportByYear', ~~year)
  //     // this.getProposalByYear(year)
  //   },
}
</script>
